import { GeneratedMutation } from '@aws-amplify/api-graphql'
import * as APITypes from '@/API'

export const updateSurveyGroupAutomaticReminders = /* GraphQL */ `
  mutation UpdateSurveyGroupAutomaticReminders(
    $input: UpdateSurveyGroupInput!
    $condition: ModelSurveyGroupConditionInput
  ) {
    updateSurveyGroup(input: $input, condition: $condition) {
      id
      automaticReminders {
        mode
        endDate
        frequencyDays
        includedIndividualIds
        firstReminderSentAt
        lastReminderSentAt
        frequencyModeStartedAt
        __typename
      }
      remindersEnabled
      __typename
    }
  }
` as GeneratedMutation<
  APITypes.UpdateSurveyGroupMutationVariables,
  APITypes.UpdateSurveyGroupMutation
>
